export default "__VITE_ASSET__BvUcG1qm__"